
    /*global server*/
    import { defineComponent, WatchStopHandle } from 'vue';
    import { Form } from "vee-validate";
    import { AxiosError, AxiosResponse } from 'axios';
    import { useProgrammatic } from '@oruga-ui/oruga-next';
    const { oruga } = useProgrammatic();
    import * as yup from "yup";
    import OutsideAccount from '../OutsideAccount/outside-account.vue';
    import { useUserStore } from '../../stores/user';


    type Nullable<T> = T | null;

    interface userState {
        user: Nullable<server.User>
    }

    interface form extends server.Accounts {
        FormWatchers: WatchStopHandle[]
    }

    interface functions {
        formWatch: Function
    }

    export default defineComponent({
        components: {
            Form,
            OutsideAccount
        },
        inject: [
            '$functions'
        ],
        data() {
            const userStore: userState = useUserStore();

            function toast() {
                oruga.notification.open({
                    message: 'Account Updated Successfully!',
                    rootClass: 'toast-notification',
                    position: 'top',
                    duration: 5000,
                    variant: 'success'
                });
            }

            return {
                userStore,
                toast,
                form: {
                    LastName: '',
                    FirstName: '',
                    MI: '',
                    Suffix: '',
                    EmailAddress: '',
                    UserID: '',
                    Password: '',
                    FormChanges: [] as string[],
                    FormWatchers: [] as WatchStopHandle[]
                } as form,
                isAccountManagementPageLoading: true as boolean,
            }
        },
        computed: {
            schema(): object {
                return yup.object().shape({
                    LastName: yup
                        .string()
                        .required("Last name is required")
                        .max(50, "Max allowed Charactors is 50"),
                    FirstName: yup
                        .string()
                        .required("First name is required")
                        .max(25, "Max allowed Charactors is 25"),
                    MI: yup
                        .string()
                        .max(1, "Max allowed Charactors is 1"),
                    Suffix: yup
                        .string()
                        .max(4, "Max allowed Charactors is 4"),
                    EmailAddress: yup
                        .string()
                        .required("Email address is required")
                        .email("Must be a valid email address")
                        .max(200, "Max allowed Charactors is 200"),
                    Password: yup
                        .string()
                        .max(200, "Max allowed Charactors is 200"),
                    confirmPassword: yup
                        .string()
                        .oneOf([yup.ref('Password'), null], "Passwords don't match")
                        .max(200, "Max allowed Charactors is 200"),
                });
            },
        },
        watch: {
        },
        created() {
        },
        mounted() {
            this.getAccountInfo();
        },
        methods: {
            getAccountInfo(): void {
                this.$axios
                    .get('account/GetAccountByUserId', {
                        params: {
                            Id: this.userStore.user?.Id || 0
                        }
                    })
                    .then(({ data }: AxiosResponse<form>) => {
                        this.form = data;
                        let outsideAccountThis = (this.$refs.outsideAccount as any);
                        // --- Reset form was causing validation to briefly set errors until the new data came in. I think because of the form watcher. --- //
                        // --- I instead opted just to clear the password fields individually here, after the data is recived. --- //
                        outsideAccountThis.$refs.confirmPasswordInput.reset();
                        outsideAccountThis.$refs.passwordInput.reset();
                        (this.$functions as functions).formWatch(this.form, this, false);
                    })
                    .catch((error: AxiosError) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.isAccountManagementPageLoading = false;
                    });
            },
            onSubmit(): void {
                this.isAccountManagementPageLoading = true;

                this.$axios
                    .patch('account/UpdateAccount', this.form)
                    .then(({ data }: AxiosResponse<boolean>) => {
                        if (data) {
                            // account update successful //
                            (this.$functions as functions).formWatch(this.form, this, true);
                            this.toast();
                            this.getAccountInfo();
                        }
                        else {
                            // account update unsuccessful //
                        }
                    })
                    .catch((error: AxiosError) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.isAccountManagementPageLoading = false;
                    });
            },
            clearfields(): void {
                (this.$refs.formValidator as any).resetForm();
            },
        }
    });
